import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, Skeleton, Badge, Empty } from "@/components/ui";
import type { Patient } from "@/types";

interface RepRow { patient: Patient; pending: number; total: number }

export default function ReportsPage() {
  const patients = useQuery({
    queryKey: ["patients-for-reports"],
    queryFn: () => api.get<Patient[]>("/patients?limit=500"),
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-xl font-semibold text-slate-50">Reports overview</h1>
        <div className="text-sm text-slate-400">Open a patient file to upload or review reports.</div>
      </div>
      {patients.isLoading ? <Card><Skeleton /></Card> :
       !patients.data || patients.data.length === 0 ? <Empty title="No patients yet." /> :
       <Card>
         <table className="table">
           <thead><tr><th>Patient</th><th>MRN</th><th>Phase</th><th></th></tr></thead>
           <tbody>
             {patients.data.map((p) => (
               <tr key={p.id}>
                 <td><Link className="text-accent hover:underline" to={`/patients/${p.id}`}>{p.full_name}</Link></td>
                 <td className="font-mono text-xs text-slate-400">{p.mrn}</td>
                 <td><Badge tone="info">{p.treatment_phase}</Badge></td>
                 <td><Link className="btn-ghost" to={`/patients/${p.id}`}>Open file</Link></td>
               </tr>
             ))}
           </tbody>
         </table>
       </Card>}
    </div>
  );
}
